export enum QuestionnaireQuestionScope {
  SCOPE_ITEM = "SCOPE_ITEM",
  SCOPE_SUPPLIER = "SCOPE_SUPPLIER"
}
